import React, { createContext, useState, useContext } from 'react';

const ChatContext = createContext();

export const ChatProvider = ({ children }) => {
  const [groupedChatHistory, setGroupedChatHistory] = useState([]);
  const [chatDetails, setChatDetails] = useState([]);

  return (
    <ChatContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        groupedChatHistory,
        setGroupedChatHistory,
        chatDetails,
        setChatDetails,
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};

export const useChatContext = () => useContext(ChatContext);
